@if (statisticGroups) {
  @for (statisticGroup of statisticGroups; track statisticGroup) {
    <h5>{{statisticGroup.name}}</h5>
    <div class="datatable m-b-64">
      <div class="datatable-header">
        <div class="datatable-header-item col">{{('General.Name' | trans)}}</div>
        @for (statistic of statisticGroup.items[0].statistics; track statistic) {
          <div class="datatable-header-item col">{{'Statistic.' + statistic.id | trans}}</div>
        }
      </div>
      @for (item of statisticGroup.items; track item) {
        <div class="datatable-row" [class.fade-out]="isLoading">
          <div class="datatable-row-item col">{{item.name}}</div>
          @for (statistic of item.statistics; track statistic) {
            <div class="datatable-row-item col">
              @if (statistic.type === 'PERCENTAGE') {
                {{statistic.value}}%
              }
              @if (statistic.type === 'CURRENCY') {
                {{statistic.value | currency}}
              }
              @if (statistic.type === 'NUMBER') {
                {{statistic.value | number}}
              }
              @if (statistic.type === 'TEXT') {
                {{statistic.value}}
              }
            </div>
          }
        </div>
      }
    </div>
  }
} @else {
  <cm-indicator class="small"></cm-indicator>
}

